import { render } from "./ElectricityReport.vue?vue&type=template&id=a6f22dc2"
import script from "./ElectricityReport.vue?vue&type=script&lang=js"
export * from "./ElectricityReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__